const SESSION_KEY_KEY = 'sessionKey'

export const getSessionKey = () => {
    return window.localStorage.getItem(SESSION_KEY_KEY)
}

export const setSessionKey = (sessionKey: string) => {
    return window.localStorage.setItem(SESSION_KEY_KEY, sessionKey)
}

export const removeSessionKey = () => {
    return window.localStorage.removeItem(SESSION_KEY_KEY)
}
